import React, { useState } from 'react';
import {
  FileUploadPropertyPiclib,
  FormPageInputItemFileUploadPiclib,
  FileUploadPiclibInput,
  FileUploadInputStatus,
  FileUploadThumbnail,
} from 'shared';
import { FormFieldInputItemProps } from '../shared';

type Props = Omit<
  FormFieldInputItemProps<
    FileUploadPropertyPiclib,
    FormPageInputItemFileUploadPiclib
  >,
  'onChange' | 'onBlur'
> & {
  onSelect: (file: File) => void;
  onChange: (file: File) => void;
  onDelete: () => void;
  onReload: () => void;
  status: FileUploadInputStatus;
  thumbnail: FileUploadThumbnail | undefined;
};

export const FileUploadPiclib: React.VFC<Props> = ({
  property,
  disabled,
  design,
  className,
  errorMessages,
  displayError,
  onSelect,
  onChange,
  onDelete,
  onReload,
  status,
  thumbnail,
}) => {
  const [file, setFile] = useState<File | null>(null);
  const handleSelect = (file: File) => {
    onSelect(file);
    setFile(file);
  };
  const handleChange = (file: File) => {
    onChange(file);
    setFile(file);
  };
  const { propertyId } = property;
  const { allowedFileMimeTypes } = property.inputFormat;
  return (
    <FileUploadPiclibInput
      propertyId={propertyId}
      disabled={disabled}
      displayError={displayError}
      errorMessages={errorMessages}
      design={design}
      className={className}
      status={status}
      thumbnail={thumbnail}
      uploadingFileSize={file?.size}
      onFileSelect={handleSelect}
      onFileChange={handleChange}
      onDelete={onDelete}
      onReload={onReload}
      accept={allowedFileMimeTypes}
    />
  );
};
